import { Alert, Button, FormControl, Grid, InputLabel, MenuItem, Modal, Select, Snackbar, TextField } from "@mui/material"
import { DataGrid, GridToolbar, GridFilterPanel } from "@mui/x-data-grid"
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import AppContext from "../../context/AppContext";

const UnidentifiedData = (props) => {

  const [UnidentifiedDataRow, setUnidentifiedDataRow] = useState([])

  const [input, setInput] = useState({
    category: '',
    assets: '',
    macAddress: props.mac ? props.mac : ''
  });
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('success');
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  // const [assetData, setAssetData] = useState([]);
  const { asset, setAsset } = useContext(AppContext)
  const { category, location } = useContext(AppContext)
  const [handleLink, sethandleLink] = useState([]);
  const [handleCategoryAsset, sethandleCategoryAsset] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    setTimeout(() => {
      const validAssetIdsLink = asset
        .filter((asset) => !asset.beacon_mac)
        .map((asset) => asset.id);
      //   const validAssetIdsLinkAttached = asset
      //     .filter((asset) => asset.beacon_mac)
      //     .map((asset) => asset.id);

      const updatedLink = category.map((categoryy) => ({
        ...categoryy,
        totalAsset: categoryy.totalAsset.filter((assets) =>
          validAssetIdsLink.includes(assets.id)
        ),
      }));
      sethandleLink(updatedLink);

      let anyCategoryHasAssets = updatedLink.some(categoryy => categoryy.totalAsset.length > 0);
      console.log({ anyCategoryHasAssets });
      sethandleCategoryAsset(anyCategoryHasAssets)
      //   const updatedLinkAttached = category.map((categoryy) => ({
      //     ...categoryy,
      //     totalAsset: categoryy.totalAsset.filter((asset) =>
      //       validAssetIdsLinkAttached.includes(asset.id)
      //     ),
      //   }));

      //   sethandleLinkAttach(updatedLinkAttached);
    }, 10);
  }, []);
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/v1/beacon/link`,
        // `http://localhost:5002/api/v1/beacon/link`,
        { category_name: input.category?.category_name, assets: input.assets, macAddress: input.macAddress }
      );
      if (response.data.status == 'success') {
        setInput({ ...input, category: '', assets: '', macAddress: '' })
        setAsset([...asset])
        setMessage(response.data.message);
        setSeverity('success');
        setOpen(true);
        setOpenModal(false)
      }
    } catch (error) {
      console.log({ error });
      setMessage(error.response?.data?.error || 'Failed to add asset');
      setSeverity('error');
      setOpen(true);
    }
  };



  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    console.log({ name, value });
    setInput({
      ...input,
      [name]: value,
    });
  };

  const handleCloseModal = () => {
    setOpenModal(false)
  }

  const handleOpenModal = async (mac) => {
    setInput({
      category: '',
      assets: '',
      macAddress: mac
    })
    setOpenModal(true)
  }

  useEffect(() => {

    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/api/v1/get/unidentified/assets?device_id=${props.gateway_id}`
        );
        if (response.data.status == 'success') {

          setUnidentifiedDataRow(response.data.result)
        }

      }
      catch (err) {
        console.log(err);
      }
    };

    fetchData();

  }, [])

  const columns = [
    {
      field: "id",
      headerName: "S.No",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"SL. No"}</strong>
      ),
      headerAlign: "center",
      align: "center",
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1,
    },

    {
      field: "mac",
      headerName: "MAC ID",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"MAC Address "}</strong>
      ),
      renderCell: (params) => (
        <div
          style={{ cursor: "pointer", textDecoration: "underline" }}
          onClick={() => handleOpenModal(params.row.mac)}
        >
          <button
            style={{
              border: "none",
              backgroundColor: "transparent",
              cursor: "pointer",
              textDecoration: "underline",
              color: 'green'
            }}
          >
            {params.row.mac}
          </button>
        </div>
      )
    },
    {
      field: "rssi",
      headerName: "rssi",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Distance"}</strong>
      ),
    },
    {
      field: "timestamp",
      headerName: "Timestamp",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"TimeStamp"}</strong>
      ),
    },
    {
      field: "battery",
      headerName: "battery",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Battery"}</strong>
      ),
    },
    {
      field: "humidity",
      headerName: "humidity",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Humidity"}</strong>
      ),
    },

    {
      field: "temperature",
      headerName: "temperature",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"Temperature"}
        </strong>
      ),
    },
    {
      field: "ip_address",
      headerName: "ip_address",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"Ip Address"}
        </strong>
      ),
    },

  ];
  const columnsMoko = [
    {
      field: "id",
      headerName: "S.No",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"SL. No"}</strong>
      ),
      headerAlign: "center",
      align: "center",
      renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1,
    },

    {
      field: "mac",
      headerName: "MAC ID",
      width: 150,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"MAC Address "}</strong>
      ),
      renderCell: (params) => (
        <div
          style={{ cursor: "pointer", textDecoration: "underline" }}
          onClick={() => handleOpenModal(params.row.mac)}
        >
          <button
            style={{
              border: "none",
              backgroundColor: "transparent",
              cursor: "pointer",
              textDecoration: "underline",
              color: 'green'
            }}
          >
            {params.row.mac}
          </button>
        </div>
      )
    },
    {
      field: "rssi",
      headerName: "rssi",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Distance"}</strong>
      ),
    },
    {
      field: "timestamp",
      headerName: "Timestamp",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"TimeStamp"}</strong>
      ),
    },
    {
      field: "battery",
      headerName: "battery",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>{"Battery"}</strong>
      ),
    },


    {
      field: "temperature",
      headerName: "temperature",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"Temperature"}
        </strong>
      ),
    },
    {
      field: "humidity",
      headerName: "humidity",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"Humidity"}
        </strong>
      ),
    },
    {
      field: "type",
      headerName: "Type",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"Type"}
        </strong>
      ),
    },
    {
      field: "runtime",
      headerName: "runtime",
      width: 200,
      headerAlign: "center",
      align: "center",
      renderHeader: () => (
        <strong style={{ color: "rgb(28, 70, 146)" }}>
          {"Runtime"}
        </strong>
      ),
    },


  ];


  return (
    <>

      <Grid item xs={12} style={{ height: 500 }}>
        {
          UnidentifiedDataRow.length > 0 && <DataGrid
            getRowId={(data) => data.mac}
            rows={UnidentifiedDataRow}
            columns={UnidentifiedDataRow[0]['owner'] == 'Moko' ? columnsMoko : columns}
            density="compact"
            components={{
              Toolbar: GridToolbar,
              FilterPanel: GridFilterPanel,
            }}
            slotProps={{
              filterPanel: {
                sx: {
                  width: "100%",          // full width responsive
                  maxWidth: "100%",
                  padding: "10px",
                  "& .MuiDataGrid-filterForm": {
                    flexDirection: "column",
                    gap: "10px",
                  },
                },
              },
            }}
          />
        }

        <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",

              width: isMobile ? 300 : 400,
              maxHeight: "100%",

              overflowY: "auto",
              overflowX: "auto",
              backgroundColor: "white",
              boxShadow: 24,
              padding: "20px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "baseline",
                justifyContent: "flex-end",
                cursor: "pointer",
              }}
              onClick={handleCloseModal}
            >
              <img style={{ width: 20, height: 20 }} src="/Close.png" />
            </div>
            {
              handleCategoryAsset == false &&
              <Alert severity="info">All assets are currently linked to the beacon. Please proceed to the configuration section to add a new asset.</Alert>

            }

            <form onSubmit={handleSubmit} style={{ flexDirection: "column", display: "flex" }}>
              <FormControl style={{ marginTop: '12px' }}>

                <InputLabel id="asset-select-label" >Category</InputLabel>

                <Select
                  labelId="asset-select-label"
                  id="asset-select"
                  name='category'
                  value={input.category?.category_name}
                  onChange={(e) => handleInputChange(e)}
                  label="Select category"
                >
                  {
                    props.link ? props.link?.map((asset) => {
                      console.log({ asset }); return (
                        <MenuItem key={asset.id} value={asset}>
                          {" "}
                          {asset.category_name}
                        </MenuItem>
                      )
                    }) : handleLink?.map((asset) => {
                      console.log({ asset }); return (
                        <MenuItem key={asset.id} value={asset}>
                          {" "}
                          {asset.category_name}
                        </MenuItem>
                      )
                    })
                  }
                  {/* {category?.map((asset) => (
                                        <MenuItem key={asset.id} value={asset}>
                                            {" "}
                                            {asset.category_name}
                                        </MenuItem>
                                    ))} */}
                </Select>

              </FormControl>

              <FormControl style={{ marginTop: '12px' }}>

                <InputLabel id="asset-select-label" >Assets</InputLabel>

                <Select
                  labelId="asset-select-label"
                  id="asset-select"
                  name='assets'
                  value={input.assets}
                  onChange={(e) => handleInputChange(e)}
                  label="Select Asset"
                >
                  {input.category?.totalAsset?.map((asset) => (
                    <MenuItem key={asset.id} value={asset.asset_name}>
                      {" "}
                      {asset.asset_name}
                    </MenuItem>
                  ))}
                </Select>

              </FormControl>
              <TextField
                label="Mac Address"
                name='macAddress'
                value={input.macAddress}
                onChange={(e) => handleInputChange(e)}
                margin="normal"
                required
              />
              <Button type="submit" variant="contained" color="primary" disabled={handleCategoryAsset == false ? true : false} >
                Add
              </Button>

            </form>

          </div>
        </Modal>

      </Grid>

      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>


    </>
  )
}


export default UnidentifiedData